import { CombinedGraphQLErrors } from '@apollo/client';
import { IntlShape } from 'react-intl';
import messages, {
  CombinedUttuCode,
  UttuCode,
  UttuSubCode,
} from './uttu.messages';

type Extensions = {
  code: UttuCode;
  subCode: UttuSubCode;
  metaData: { [key: string]: object };
};

export interface UttuError extends Error {
  response:
    | undefined
    | {
        errors: { message?: string; extensions?: Extensions }[];
      };
}

export const getUttuError = (e: UttuError) =>
  e.response?.errors?.[0]?.message ?? null;

export const getStyledUttuError = (
  e: UttuError,
  generalMessage: string,
  fallback = '',
) =>
  getUttuError(e)
    ? `${generalMessage}: ${getUttuError(e)}`
    : `${generalMessage}. ${fallback}`;

export const getInternationalizedUttuError = (intl: IntlShape, e: Error) => {
  let error;

  if (CombinedGraphQLErrors.is(e)) {
    error = e.errors[0];
  } else {
    error = (e as UttuError).response?.errors?.[0];
  }

  if (error?.extensions?.code) {
    const { code, subCode } = error.extensions;
    const messageCode = (subCode ? `${code}_${subCode}` : code) as
      UttuCode | CombinedUttuCode;

    const errorMessage = messages[messageCode] ?? messages[UttuCode.UNKNOWN];

    return intl.formatMessage({ id: errorMessage });
  }

  return intl.formatMessage({ id: messages[UttuCode.UNKNOWN] });
};
